/**
 * `/slack/link?token=` — the link Draper sends someone who pressed one of its buttons before Dreamwell knew who they
 * are in Slack. A plain validator, not zod: route validators ship in the entry chunk the sign-in page pays for. Only a
 * URL-safe token of a sane length is kept; anything else is dropped (the page then says there is nothing to connect).
 */
export interface SlackLinkSearch {
  token?: string;
}

export interface SlackLinkSearchInput {
  token?: string;
}

/** The server's tokens are base64url claims, a dot, and a base64url signature. */
const TOKEN = /^[A-Za-z0-9._~-]{16,1024}$/;

export function parseSlackLinkSearch(input: SlackLinkSearchInput | Record<string, unknown>): SlackLinkSearch {
  const token = (input as Record<string, unknown>).token;
  // Always answer the key: the router lays this answer over the address's own search, so a token left out would
  // reach the page as it was typed.
  return { token: typeof token === 'string' && TOKEN.test(token) ? token : undefined };
}
